/** @jsxImportSource @emotion/react */
import { ColorStatus } from 'ui'
import { Badge } from '@/components/web/Badge'
import { BatchStatus } from '@/types/batch'

type Props = {
  status: BatchStatus
  days: number | null
  compact?: boolean
}

export function StaffReviewTimer({ status, days, compact }: Props) {
  if (status !== 'Staff - Review' || days === null) return null

  let colorStatus: ColorStatus = 'info'
  if (days >= 10) colorStatus = 'danger'
  else if (days >= 7) colorStatus = 'warning'

  return (
    <Badge status={colorStatus} compact={compact}>
      {days} {days === 1 ? 'day' : 'days'}
    </Badge>
  )
}
